import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { environment } from '../../environments/environment';

@Injectable()
export class CaixaEntradaService {
    private urlModulo = `${environment.urlAPI}/caixaentrada`;

    constructor(private http: HttpClient) { }

    /**
     * Recupera os itens da Caixa de Entrada pelo ID do usuário
     */
    public getItensCaixaEntrada(codUsuario, fornecedor?): Promise<any> {
        let params = new HttpParams().set('codigo', codUsuario);

        if (fornecedor) {
            params = params.append('fornecedor', fornecedor);
        }

        return new Promise((resolve, reject) => {
            this.http.get(`${this.urlModulo}`, { params })
                .subscribe({
                    next: (response: any) => {
                        if (response.type === true) {
                            resolve(response.data.caixaentrada);
                        } else {
                            reject(response.data);
                        }
                    },
                    error: (error) => {
                        console.error('Erro ao obter itens da caixa de entrada:');
                        reject(error);
                    }
                });
        });
    }

    /**
     * Recupera itens da agenda
     */
    public getItensAgenda(codUsuario, visualizacao, ano?): Promise<any> {
        let params = new HttpParams()
            .set('codigo', codUsuario)
            .set('visualizacao', visualizacao);
            
        if (ano) {
            params = params.append('ano', ano);
        }

        return new Promise((resolve, reject) => {
            this.http.get(`${this.urlModulo}-agenda`, { params })
                .subscribe({
                    next: (response: any) => {
                        if (response.type === true) {
                            resolve(response.data.agenda);
                        } else {
                            reject(response.data);
                        }
                    },
                    error: (error) => {
                        const msg =
                            (error && error.error && error.error.message) ||
                            (error && error.message) ||
                            error;
                        console.error('Erro ao obter itens da agenda:', msg, error);
                        reject(error);
                    }
                });
        });
    }

    /**
     * Recupera fornecedores pela estação atual
     */
    public getFornecedoresByEstacaoAtual(codEstacaoAtual): Promise<any> {
        const params = new HttpParams().set('codEstacaoAtual', codEstacaoAtual);

        return new Promise((resolve, reject) => {
            this.http.get(`${this.urlModulo}-byCodEstacaoAtual`, { params })
                .subscribe({
                    next: (response: any) => {
                        if (response.type === true) {
                            resolve(response.data.itens);
                        } else {
                            reject(response.data);
                        }
                    },
                    error: (error) => {
                        console.error('Erro ao obter fornecedores por estação atual:');
                        reject(error);
                    }
                });
        });
    }

    /**
     * Recupera fornecedor pela lista de códigos de workflow
     */
    public getFornecedorByListaCodWorkflow(codWorkflows, codEstacao): Promise<any> {
        const params = new HttpParams()
            .set('codWorkflows', codWorkflows)
            .set('codEstacao', codEstacao);

        return new Promise((resolve, reject) => {
            this.http.get(`${this.urlModulo}-byListaCodWorkflow`, { params })
                .subscribe({
                    next: (response: any) => {
                        if (response.type === true) {
                            resolve(response.data.itens);
                        } else {
                            reject(response.data);
                        }
                    },
                    error: (error) => {
                        console.error('Erro ao obter fornecedor por lista de códigos de workflow:');
                        reject(error);
                    }
                });
        });
    }

    /**
     * Recupera processos de workflow
     */
    public getProcessosWorkflow(codUsuario, fornecedor?): Promise<any> {
        let params = new HttpParams().set('codUsuario', codUsuario);
        if (fornecedor) {
            params = params.append('fornecedor', fornecedor);
        }

        return new Promise((resolve, reject) => {
            this.http.get(`${this.urlModulo}-processos`, { params })
                .subscribe({
                    next: (response: any) => {
                        if (response.type === true) {
                            resolve(response.data.processos);
                        } else {
                            reject(response.data);
                        }
                    },
                    error: (error) => {
                        console.error('Erro ao obter processos de workflow:');
                        reject(error);
                    }
                });
        });
    }

    /**
     * Recupera item da agenda pelo código de workflow
     */
    public getItemAgendaByCodWorkflow(codWorkflow): Promise<any> {
        const params = new HttpParams().set('codWorkflow', codWorkflow);

        return new Promise((resolve, reject) => {
            this.http.get(`${this.urlModulo}-itemagendabycodworkflow`, { params })
                .subscribe({
                    next: (response: any) => {
                        if (response.type === true) {
                            resolve(response.data.agenda);
                        } else {
                            reject(response.data);
                        }
                    },
                    error: (error) => {
                        console.error('Erro ao obter item da agenda por código de workflow:');
                        reject(error);
                    }
                });
        });
    }
}


// WEBPACK FOOTER //
// /app/src/app/services/caixaentrada.service.ts